import React from 'react';
import { Box, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildAdornmentTextFieldSx, fieldLabelSx } from './formFieldStyles';
import { STOCK_UNITS } from '../../constants/Stock';
import { stockUnitFieldSuffix } from '../../utils/stockQuantityUtils';
import { BRAND } from '../../theme/brandTokens';

const unitSelectSx = {
  minWidth: 76,
  height: 48,
  fontWeight: 600,
  fontSize: 16,
  color: BRAND.textMuted,
  backgroundColor: 'transparent',
  '&:before, &:after': { display: 'none' },
  '& .MuiSelect-select': {
    py: 0,
    pl: 1.75,
    pr: '28px !important',
    display: 'flex',
    alignItems: 'center',
    height: 48,
    boxSizing: 'border-box',
  },
  '& .MuiSelect-icon': {
    color: BRAND.textMuted,
    right: 6,
  },
};

const AmountWithUnitField = ({
  id,
  label,
  quantity,
  stockUnit,
  onQuantityChange,
  onUnitChange,
  error,
  required = false,
  quantityDisabled = false,
  unitDisabled = false,
  min = 0,
  step = '0.001',
}) => {
  const { t } = useTranslation();
  const unit = stockUnit || 'Unit';

  return (
    <Box>
      {label ? (
        <Typography variant="subtitle2" sx={fieldLabelSx}>
          {required ? `${label} *` : label}
        </Typography>
      ) : null}
      <TextField
        id={id}
        type="number"
        value={unit === 'Unit' ? 1 : quantity}
        onChange={(event) => onQuantityChange(event.target.value)}
        inputProps={{
          min,
          step,
          readOnly: quantityDisabled || unit === 'Unit',
          'aria-label': label,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Select
                id={id ? `${id}-unit` : undefined}
                value={unit}
                disabled={unitDisabled}
                onChange={(event) => onUnitChange(event.target.value)}
                variant="standard"
                disableUnderline
                SelectDisplayProps={{
                  'aria-label': t('productsManagement.fields.stockUnit'),
                }}
                renderValue={(value) => stockUnitFieldSuffix(value)}
                MenuProps={{ disableScrollLock: true }}
                sx={unitSelectSx}
              >
                {STOCK_UNITS.map((item) => (
                  <MenuItem key={item} value={item}>
                    {t(`productsManagement.units.${item}`)}
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ),
        }}
        error={Boolean(error)}
        sx={{
          ...buildAdornmentTextFieldSx(Boolean(error)),
          '& .MuiInputAdornment-root': {
            ...buildAdornmentTextFieldSx(Boolean(error))['& .MuiInputAdornment-root'],
            paddingLeft: 0,
            paddingRight: 0,
          },
        }}
        fullWidth
      />
      {error ? (
        <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, display: 'block' }}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
};

export default AmountWithUnitField;
